<template>
    <section
        ref="section25"
        :class="[
            Object.keys(validationErrors).length > 0 ? 'has-errors' : '',
            'mx-auto flex h-full flex-col',
        ]"
    >
        <v-add-listing-head :routes="routes" :step="25"></v-add-listing-head>
        <main
            class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
        >
            <figure class="relative flex w-full max-w-3xl flex-col gap-11">
                <figure class="ml-auto mr-auto flex w-full max-w-xl gap-3">
                    <div><v-icon icon="energy-card" size="8"></v-icon></div>
                    <div class="flex flex-col justify-center">
                        <div class="text-heading-3-desktop">
                            Ali ima nepremičnina energetsko izkaznico?
                        </div>
                    </div>
                    <v-lightbox is-authenticated footerless>
                        <template v-slot:trigger>
                            <div
                                class="absolute right-0 top-0 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-green-25"
                            >
                                <v-icon icon="question-mark" size="4"></v-icon>
                            </div>
                        </template>
                        <template v-slot:head>
                            <div class="flex items-start">
                                <v-icon
                                    icon="question-mark"
                                    class="mr-2.5"
                                    size="4.5"
                                ></v-icon>
                                <div>
                                    Dodatne informacije
                                </div>
                            </div>
                        </template>
                        <template v-slot:content>
                            <p class="mb-[10px] text-icon-text-medium">
                                Energetska izkaznica
                            </p>
                            <p class="text-body-regular">
                                Pri obstoječih objektih je energetska izkaznica
                                po zakonu obvezna. V kolikor energetske
                                izkaznice nimate, se pozanimajte če ta že
                                obstaja ali naročite novo. V kolikor jo boste
                                dobili kasneje, kliknite na "Predložena ob
                                ogledu"
                            </p>
                        </template>
                    </v-lightbox>
                </figure>
                <figure class="flex flex-col gap-8 lg:gap-11">
                    <form
                        method="POST"
                        :action="routes.submitForm"
                        id="energy-class"
                    >
                        <v-csrf-token></v-csrf-token>
                        <figure
                            class="grid grid-cols-1 grid-rows-1 gap-4 lg:flex lg:grid-cols-2 lg:flex-wrap lg:justify-center lg:gap-4 lg:gap-6"
                        >
                            <div
                                name="aliImaNepremicninaEnergetskoIzkaznico"
                                :class="[
                                    'tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]',
                                    validationErrors.energieausweistyp
                                        ? 'has-errors'
                                        : '',
                                ]"
                            >
                                <input
                                    type="radio"
                                    name="energieausweistyp"
                                    id="aliImaNepremicninaEnergetskoIzkaznicoDa"
                                    value="Endenergiebedarf"
                                    class="hidden"
                                    v-model="energyCertificateType"
                                />

                                <label
                                    for="aliImaNepremicninaEnergetskoIzkaznicoDa"
                                    class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                                >
                                    <v-icon
                                        icon="circle-check"
                                        size="5"
                                    ></v-icon>
                                    <span
                                        class="pointer-events-none select-none"
                                        >Da</span
                                    >
                                </label>
                            </div>
                            <div
                                name="aliImaNepremicninaEnergetskoIzkaznicoPredlozenaObOgledu"
                                :class="[
                                    'tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]',
                                    validationErrors.energieausweistyp
                                        ? 'has-errors'
                                        : '',
                                ]"
                            >
                                <input
                                    type="radio"
                                    name="energieausweistyp"
                                    id="aliImaNepremicninaEnergetskoIzkaznicoPredlozenaObOgledu"
                                    value="liegtZurBesichtigungVor"
                                    class="hidden"
                                    v-model="energyCertificateType"
                                />

                                <label
                                    for="aliImaNepremicninaEnergetskoIzkaznicoPredlozenaObOgledu"
                                    class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all lg:h-[68px] lg:py-0"
                                >
                                    <v-icon
                                        icon="find-in-page"
                                        size="5"
                                    ></v-icon>
                                    <span
                                        class="pointer-events-none select-none lg:flex-1"
                                        >Predložena ob ogledu</span
                                    >
                                </label>
                            </div>
                            <div
                                name="aliImaNepremicninaEnergetskoIzkaznicoObjektNePotrebuje"
                                :class="[
                                    'tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]',
                                    validationErrors.energieausweistyp
                                        ? 'has-errors'
                                        : '',
                                ]"
                            >
                                <input
                                    type="radio"
                                    name="energieausweistyp"
                                    id="aliImaNepremicninaEnergetskoIzkaznicoObjektNePotrebuje"
                                    value="es besteht keine Pflicht!"
                                    class="hidden"
                                    v-model="energyCertificateType"
                                />

                                <label
                                    for="aliImaNepremicninaEnergetskoIzkaznicoObjektNePotrebuje"
                                    class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all lg:h-[68px] lg:py-0"
                                >
                                    <v-icon icon="cancel" size="5"></v-icon>
                                    <span
                                        class="pointer-events-none select-none lg:flex-1"
                                        >Objekt ne potrebuje</span
                                    >
                                </label>
                            </div>
                        </figure>
                        <template
                            v-if="energyCertificateType == 'Endenergiebedarf'"
                        >
                            <figure
                                class="my-11 ml-auto mr-auto w-full max-w-lg"
                            >
                                <ul
                                    class="grid grid-cols-4 flex-col gap-x-5 gap-y-8"
                                >
                                    <li class="col-span-2">
                                        <div
                                            :class="[
                                                'input group relative flex flex-col gap-[10px]',
                                                validationErrors.energieausweis_gueltig_bis
                                                    ? 'has-errors'
                                                    : '',
                                            ]"
                                        >
                                            <label
                                                for="energetskaIzkaznicaVeljavnaDo"
                                                class="w-full text-body-medium-button"
                                            >
                                                <div
                                                    class="label flex flex-col gap-[10px]"
                                                >
                                                    <div
                                                        class="flex items-center gap-3"
                                                    >
                                                        <v-icon
                                                            icon="calendar-check"
                                                            size="4"
                                                        ></v-icon>
                                                        <span>
                                                            Veljavna do
                                                            <sup>*</sup></span
                                                        >
                                                    </div>
                                                </div>
                                            </label>
                                            <v-datepicker
                                                v-model="
                                                    energyCertificateValidUntil
                                                "
                                                :formatter="dateFormatter"
                                                id="datumKdajBoVseljivo"
                                                name="energieausweis_gueltig_bis"
                                                placeholder="Datum"
                                                as-single
                                            />
                                        </div>
                                    </li>
                                    <li class="col-span-2">
                                        <div
                                            :class="[
                                                'input group relative flex flex-col gap-[10px]',
                                                validationErrors.energieverbrauchskennwert
                                                    ? 'has-errors'
                                                    : '',
                                            ]"
                                        >
                                            <label
                                                for="poraba"
                                                class="w-full text-body-medium-button"
                                            >
                                                <div
                                                    class="label flex flex-col gap-[10px]"
                                                >
                                                    <div
                                                        class="flex items-center gap-3"
                                                    >
                                                        <v-icon
                                                            icon="gas-meter"
                                                            size="4"
                                                        ></v-icon>
                                                        <span>
                                                            Poraba
                                                            <sup>*</sup></span
                                                        >
                                                    </div>
                                                </div>
                                            </label>
                                            <input
                                                id="poraba"
                                                type="number"
                                                name="energieverbrauchskennwert"
                                                placeholder="0"
                                                v-model="energyConsumption"
                                            />
                                            <span
                                                class="absolute bottom-[18px] right-6 text-body-medium-button"
                                                :class="energyConsumption ? 'text-black-78' : 'text-black-40'"
                                                >kWh/m<sup>2</sup>a</span
                                            >
                                        </div>
                                    </li>
                                </ul>
                            </figure>
                            <figure class="ml-auto mr-auto w-full">
                                <div
                                    :class="[
                                        'energy-efficiency group relative',
                                        validationErrors.energyClass
                                            ? 'has-errors'
                                            : '',
                                    ]"
                                >
                                    <label
                                        for="energyEfficiency"
                                        class="mb-4 block w-full text-body-medium-button"
                                    >
                                        <div
                                            class="label flex flex-col gap-[10px]"
                                        >
                                            <div
                                                class="flex items-center gap-3"
                                            >
                                                <v-icon
                                                    icon="energy-leaf"
                                                    size="4"
                                                ></v-icon>
                                                <span>
                                                    Razred energetske
                                                    učinkovitosti
                                                    <sup>*</sup></span
                                                >
                                            </div>
                                        </div>
                                    </label>
                                    <span
                                        class="mb-2 flex items-center justify-between px-2.5"
                                    >
                                        <span class="text-sm text-gray-500">
                                            A1
                                        </span>
                                        <span class="text-sm text-gray-500">
                                            A2
                                        </span>
                                        <span class="text-sm text-gray-500">
                                            B1
                                        </span>
                                        <span class="text-sm text-gray-500">
                                            B2
                                        </span>
                                        <span class="text-sm text-gray-500">
                                            C
                                        </span>
                                        <span class="text-sm text-gray-500">
                                            D
                                        </span>
                                        <span class="text-sm text-gray-500">
                                            E
                                        </span>
                                        <span class="text-sm text-gray-500">
                                            F
                                        </span>
                                        <span class="text-sm text-gray-500">
                                            G
                                        </span>
                                    </span>
                                    <input
                                        id="energyEfficiency"
                                        type="range"
                                        min="1"
                                        max="9"
                                        step="1"
                                        class="h-8 w-full cursor-pointer appearance-none rounded-full bg-gray-200 dark:bg-gray-700"
                                        v-model="selectedEnergyClass"
                                    />
                                    <input
                                        name="energyClass"
                                        v-model="energyClass"
                                        type="hidden"
                                    />
                                </div>
                            </figure>
                            <figure
                                class="ml-auto mr-auto mt-11 w-full max-w-lg"
                            >
                                <v-checkbox
                                    icon="water-voc"
                                    class="text-small-text-medium text-black-78"
                                    label="Topla voda vključena"
                                    checkbox-position="right"
                                    name="warmWater"
                                    :checked="Boolean(warmWaterCasted)"
                                    @vchanged="hotWaterIncludedInCalculations = !hotWaterIncludedInCalculations"
                                ></v-checkbox>
                                <input
                                    type="text"
                                    name="warmwasserEnthalten"
                                    class="hidden"
                                    v-model="warmWaterCasted"
                                />
                            </figure>
                        </template>
                    </form>
                </figure>
            </figure>
        </main>
        <v-add-listing-foot>
            <a
                @click="submitForm('energy-class')"
                class="button button--md h-[48px] w-[240px] px-6"
            >
                <label class="text-small-text-medium">Nadaljujte</label>
                <v-icon icon="arrow-right" size="4"></v-icon>
            </a>
        </v-add-listing-foot>
    </section>
</template>
<script>
import AddListingFootVue from "../AddListingFoot.vue";
import AddListingHeadVue from "../AddListingHead.vue";
import VueTailwindDatepicker from "vue-tailwind-datepicker";

export default {
    components: {
        "v-add-listing-foot": AddListingFootVue,
        "v-add-listing-head": AddListingHeadVue,
        "v-datepicker": VueTailwindDatepicker,
    },
    props: {
        old: {
            type: Object,
            required: false,
            default: {},
        },
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        stepData: {
            type: Object,
            required: true,
            default: {},
        },
    },
    data() {
        return {
            energyCertificateType: null,
            energyConsumption: null,
            hotWaterIncludedInCalculations: null,
            energyClass: null,
            selectedEnergyClass: 1, // selected value
            energyCertificateValidUntil: null,
            dateFormatter: {
                date: "D.M.YYYY",
                month: "MMM",
            },
        };
    },
    mounted() {
        this.energyCertificateType = this.old.energieausweistyp
            ? this.old.energieausweistyp
            : this.stepData.energieausweistyp;
        this.energyConsumption = this.old.energieverbrauchskennwert
            ? this.old.energieverbrauchskennwert
            : this.stepData.energieverbrauchskennwert;
        this.hotWaterIncludedInCalculations = this.stepData.warmwasserEnthalten;
        this.energyClass = this.old.energyClass
            ? this.old.energyClass
            : this.stepData.energyClass;

        if (this.stepData.energyClass != null) {
            this.selectedEnergyClass = this.mapEnergyClass(
                null,
                this.stepData.energyClass
            );
        }
        if (this.old.energyClass != null) {
            this.selectedEnergyClass = this.mapEnergyClass(
                null,
                this.old.energyClass
            );
        }

        this.energyCertificateValidUntil = this.old.energieausweis_gueltig_bis
            ? this.old.energieausweis_gueltig_bis
            : this.stepData.energieausweis_gueltig_bis
            ? this.stepData.energieausweis_gueltig_bis
            : "";
    },
    computed: {
        warmWaterCasted() {
            return this.hotWaterIncludedInCalculations ? 1 : 0;
        },
        energyClassIndexComputed() {
            this.energyClass = this.mapEnergyClass(
                this.selectedEnergyClass,
                null
            );
        },
        validated() {
            if (this.energyCertificateType == null) return false;

            if (this.energyCertificateType == "Endenergiebedarf") {
                if (
                    !this.energyConsumption ||
                    !this.energyCertificateValidUntil
                )
                    return false;
            }

            return true;
        },
    },
    watch: {
        selectedEnergyClass: {
            handler(newValue) {
                if (newValue != null) {
                    this.energyClass = this.mapEnergyClass(newValue, null);
                }
            },
        },
    },
    methods: {
        mapEnergyClass(integer = null, char = null) {
            /*
             * int | label | onOffice
             *  1 = A1 = A
             *  2 = A2 = A+
             *  3 = B1 = B
             *  4 = B2 = ind_Schl_3153
             *  5 = C = C
             *  6 = D = D
             *  7 = E = E
             *  8 = F = F
             *  9 = G = G
             */

            if (integer == 1) return "A";
            if (integer == 2) return "A+";
            if (integer == 3) return "B";
            if (integer == 4) return "ind_Schl_3153";
            if (integer == 5) return "C";
            if (integer == 6) return "D";
            if (integer == 7) return "E";
            if (integer == 8) return "F";
            if (integer == 9) return "G";

            if (char == "A") return 1;
            if (char == "A+") return 2;
            if (char == "B") return 3;
            if (char == "ind_Schl_3153") return 4;
            if (char == "C") return 5;
            if (char == "D") return 6;
            if (char == "E") return 7;
            if (char == "F") return 8;
            if (char == "G") return 9;
        },
        submitForm(formId) {
            document.getElementById(formId).submit();
        },
    },
};
</script>
